import * as React from 'react';
import FormView from 'components/FormView';
import { IDairyFields } from '../interfaces';

class Diary extends React.PureComponent<IDairyFields> {

  componentDidMount(): void {
    const { path, onInitialLoad } = this.props;
    if (path) {
      switch (path) {
        case '/rfc-enquiry/sales-diary':
          onInitialLoad('SalesDiary');
          break;
        case '/rfc-enquiry/sales-diary/diary-details':
          onInitialLoad('DiaryDetails');
          break;
        default:
          onInitialLoad('RFCDetails');
      }
    }
  }
  getDiary = () => {
    this.props.getDiary();
  }

  getInitialValues = () => {
    const {
      selectedTab, selectedRFC
    } = this.props;
    const params = new URLSearchParams(location.search);
    const RFCNumber = (selectedRFC && selectedRFC.RFCNumber) || params.get('RFCNumber');
    switch (selectedTab) {
      case 'DiaryDetails':
      case 'SalesDiary':
        return {
          params: RFCNumber && {
              RFCNumber: RFCNumber
            }
        };
      default: return null;
    }
  }

  render(): React.ReactNode {
    const { isBrowseLookUpOpen, selectedTab, selectedForm, operationMode, isLoading, summaryTableRenderer } = this.props;
    const initialValues = this.getInitialValues();

    return (selectedForm &&
      <React.Fragment>
        <FormView
          isLoading={isLoading}
          formName={(selectedTab === 'SalesDiary' && 'Diary') || selectedTab}
          browseLookUpOpen={isBrowseLookUpOpen}
          browseLookUpComponent={selectedTab}
          schema={selectedForm}
          includeTabsHeight={false}
          initialValues={initialValues}
          operationMode={operationMode}
          enableReinitialize={true}
          summaryTableRenderer={summaryTableRenderer}
        />
      </React.Fragment>
    );
  }
}

export default Diary;
